import React, { FC } from 'react';
import { observer } from 'mobx-react';

import { CRM_CALLS_WIDGET_APP_NAME } from '../../constants';
import { SuspenseMicroApp, SuspenseMicroAppProps } from '../micro-app/suspense-micro-app';

export const CrmCallsWidgetApp: FC<SuspenseMicroAppProps> = observer((props) => {
    return <SuspenseMicroApp {...props} appName={CRM_CALLS_WIDGET_APP_NAME} />;
});
